import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { RestService } from '../services/rest.service';
import { ConfigService } from '../services/config.service';
import { Title } from '@angular/platform-browser';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { NotificationsService } from 'angular4-simple-notifications';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { SweetAlertService } from 'angular-sweetalert-service';
import { EventEmitter } from '@angular/core';
// import { MessageService } from 'primeng/api';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class GlobalService {
  LoggedUserLocal: any;
  userSymbolsDefault: any;
  DealerId = 0;
  AdminId: number = 1;
  
  profileupdate=new EventEmitter();
  subvar:Subscription;
  profileupdate1=new EventEmitter();
  subvar1:Subscription;

  LoggedInSrc = new BehaviorSubject(0);
  LoggedIn = this.LoggedInSrc.asObservable();

  ConfigSrc = new BehaviorSubject({});
  Config = this.ConfigSrc.asObservable();

  WalletSrc = new BehaviorSubject({
    sWalletId: 0,
    uBalance: 0,
    uPending: 0,
    uPending_Pos: 0,
    uTimestamp: null
  });
  Wallet = this.WalletSrc.asObservable();

  config: any;
  AppName = 'Admin';

  contest=new BehaviorSubject({});
  contestData= this.contest.asObservable();


  LoggedUserSrc = new BehaviorSubject({});
  LoggedUser = this.LoggedUserSrc.asObservable();
  account_open = new BehaviorSubject({});
  account_open_type = this.account_open.asObservable();
  workSrc = new BehaviorSubject({});
  workUser = this.workSrc.asObservable();

  UserData = new BehaviorSubject({});
  User = this.UserData.asObservable();

  isAdminSrc = new BehaviorSubject(false);
  isAdmin = this.isAdminSrc.asObservable();
  localDealerCode: any;
  localDealerEmail: any;
  localDealerName: any;
  localDealermasterID: string;
  localDealerwallet: string;
  data: any;
  init = {
    Dealerid: 1001
  };

  getSignalByRange(params: {
    MentorId: any;
    dtFrom_Str: string;
    dtTo_Str: string;
  }): any {
    throw new Error('Method not implemented.');
  }


  constructor(
    protected rest: RestService,
    protected conf: ConfigService,
    private titleService: Title,
    protected router: Router,
    private spiner: Ng4LoadingSpinnerService,
    private Notify: NotificationsService,
    public alertService: SweetAlertService,
    public http: HttpClient
  ) {

    this.loadData();

    this.setTitle(this.router.url);
  }

  
  loadData() {

    this.LoggedUserSrc.next(JSON.parse(localStorage.getItem('LoggedUser')));
    this.LoggedUserLocal = JSON.parse(localStorage.getItem('LoggedUser'));
    this.userSymbolsDefault = JSON.parse(localStorage.getItem('symbols'));
    this.localDealerCode = localStorage.getItem('LoggedDealerCode');
    this.localDealerEmail = localStorage.getItem('LoggedDealerEmail');
    this.localDealerName = localStorage.getItem('LoggedDealerName');
    this.localDealermasterID = localStorage.getItem('LoggedDealermasterid');
    this.localDealerwallet = localStorage.getItem('LoggedDealerwalletID');

    try {
      this.UserData.next(
        JSON.parse(localStorage.getItem('LoggedUser')).sProfile
      );
    } catch (e) {}

    console.log('--->', this.localDealerCode);
  }
  load() {
    this.Config.subscribe(data => (this.data = data));
  }

  getData(param:any){
    this.contest.next(param);
  }

  profileupfunction(){
    this.profileupdate.emit();
    this.profileupdate1.emit();
  }




  ADD_PROFILE_WHATSAPP(param){
    return this.rest.post('ADD_PROFILE_WHATSAPP',param)
  }

  RESEND_WHATSAPP_OTP(param){
    return this.rest.get('RESEND_WHATSAPP_OTP',param)
  }

  sendTextMessage(params){
    let p = this.http.get(`https://app.wappapi.info/api/send-text.php?number=${params.number}&msg=${params.msg}&apikey=b047ad90612eb877133ac2b136e3bb9031cc8ce3&instance=NEPcM4i2rta53un`, {responseType: 'text'});
    return p;
  }

  VERIFY_WHATSAPP_OTP(param){
    return this.rest.get('VERIFY_WHATSAPP_OTP',param)
  }

  MAKE_WITHDRAW_WALLET_BY_VOUCHER(param){
    return this.rest.post('MAKE_WITHDRAW_WALLET_BY_VOUCHER',param)
  }

  SUBSCRIBE_PROMOTION_STATUS(param){
    return this.rest.get('SUBSCRIBE_PROMOTION_STATUS',param)
  }

  GET_IB_CLNT_COMMISSION_SUMMARY(param){
    return this.rest.get('GET_IB_CLNT_COMMISSION_SUMMARY',param)
  }
  
  GET_GENERIC_REQ_RESP_BY_EMAIL(param){
    return this.rest.get('GET_GENERIC_REQ_RESP_BY_EMAIL',param)
  }
  GET_IB_CLNT_COMMISSION_DETAILS(param){
    return this.rest.get('GET_IB_CLNT_COMMISSION_DETAILS',param)
  }

  GET_IB_CLNT_COMMISSION_DAILY(param){
    return this.rest.get('GET_IB_CLNT_COMMISSION_DAILY',param)
  }

  GET_IB_COMM_WALLET_TRANS(param){
    return this.rest.get('GET_IB_COMM_WALLET_TRANS',param)
  }

  SUBSCRIBE_ACCOUNT_COPY(param){
    return this.rest.post('SUBSCRIBE_ACCOUNT_COPY',param)
  }
  
  UPDATE_PROFILE_PHONE_STATUS(param) {
    return this.rest.get('UPDATE_PROFILE_PHONE_STATUS', param);
  }
  GET_WORKSPACE(param) {
    return this.rest.get('GET_WORKSPACE', param);
  }
  ADD_GENERIC_REQ_RESP(param) {
    return this.rest.post('ADD_GENERIC_REQ_RESP', param);
  }
  UPDATE_GENERIC_REQ_RESP_STATUS(param) {
    return this.rest.get('UPDATE_GENERIC_REQ_RESP_STATUS', param);
  }
  GET_GENERIC_REQ_RESP(param) {
    return this.rest.get('GET_GENERIC_REQ_RESP', param);
  }
  getIbCommDetails(param) {
    return this.rest.get('GET_IB_COMMISSION_DETAILS', param);
  }
  getIbCommSumary(param) {
    return this.rest.get('GET_IB_COMMISSION_SUMMARY', param);
  }
  getClientLogs(param) {
    return this.rest.get("GET_CLIENT_LOGS", param);
  }
  SIGNUP_PROFILE_ONLY(param) {
    return this.rest.post('MAKE_SIGNUP_AFTER_VERIFICATION_ONLY_PROFILE', param);
  }

  ana2() {
    return this.http.get("https://metiadigital.com:3000/kyc/aaana2_USDT");
  }
  changeAccPlanID(param) {
    return this.rest.get("CHANGE_ACCOUNT_PLAN", param);
  }
  loginUser(param) {
    console.log(param);
    return this.rest.get('LOGIN_USER', param);
  }
  getProfileByIB(param) {
    return this.rest.get('GET_PROFILEID_BYIB', param);
  }
  GET_USER_ACTIVE_TIMER(param) {
    return this.rest.get('GET_USER_ACTIVE_TIMER', param);
  }
  GET_AFHL_COMMISISON(param) {
    return this.rest.get('GET_AFHL_COMMISISON', param);
  }
  checkReferCode(param) {
    return this.rest.get('VALID_REFER_CODE', param);
  }
  openInvestmentAccount(param) {
    return this.rest.get('OPEN_INVESTMENT_ACCOUNT', param);
  }
  payWalletAccount(param) {
    return this.rest.get('PROCESS_PAY_TO_WALLET_ACCOUNT', param);
  }
  MAKE_AFHL_WITHDRAW_WALLET(param) {
    return this.rest.get('MAKE_AFHL_WITHDRAW_WALLET', param);
  }
  GET_AFHL_USER_TRANS(param) {
    return this.rest.get('GET_AFHL_USER_TRANS', param);
  }
  getProfileAccounts(param) {
    return this.rest.get('GET_PROFILE_ACCOUNTS', param);
  }
  getWalletInfo(param) {
    return this.rest.get('GET_WALLET_INFO', param);
  }
  getPackage(param) {
    return this.rest.get('GET_ACCOUNT_PLAN_USER', param);
  }
   getAccountPlan(param) {
    return this.rest.get('GET_ACCOUNT_PLAN_USER', param);
  }
  getLeverage(param) {
    return this.rest.get('GET_PACKAGE_LEVERAGE', param);
  }
  openAcc(param) {
    return this.rest.post('OPEN_ACCOUNT', param);
  }
  OPEN_ACCOUNT_BY_REFERRAL(param) {
    return this.rest.post('OPEN_ACCOUNT_BY_REFERRAL', param);
  }
  
  GET_PROMOTION_CONTEST(param) {
    return this.rest.get('GET_PROMOTION_CONTEST', param);
  }

  GET_CASH_CARD_BY_PROFILE(param) {
    return this.rest.get('GET_CASH_CARD_BY_PROFILE', param);
  }

  
  VALIDATE_USER_WITHDRAW_LIMII(param) {
    return this.rest.get('VALIDATE_USER_WITHDRAW_LIMII', param);
  }
  

  configureAcc(param) {
    return this.rest.post('CONFIGURE_ACCOUNT', param);
  }
  getUserWorkspace(param) {
    return this.rest.get('GET_LOGIN_PROFILE_WORKSPACE', param);
  }
  makeSignupVerification(param) {
    return this.rest.post('MAKE_SIGNUP_VERIFICATION', param);
  }
  MAKE_GENERIC_REQ_SUBSCRIBE(param) {
    return this.rest.post('MAKE_GENERIC_REQ_SUBSCRIBE', param);
  }
  getPackageByType(param) {
    return this.rest.get('GET_ACCOUNT_PLAN_USER', param);
  }
  getLeverageByPackage(param) {
    return this.rest.get('GET_PACKAGE_LEVERAGE', param);
  }
  passRequest(param) {
    return this.rest.get('MAKE_RESET_PASSWORD_REQ', param);
  }
  changeMasterPassword(param) {
    return this.rest.get('CHANGE_MASTER_PASSWORD', param);
  }
  changeInvestorPassword(param) {
    return this.rest.get('CHANGE_INVESTOR_PASSWORD', param);
  }
  changeLev(param) {
    return this.rest.get('CHANGE_LEVERAGE', param);
  }
  getOpenPositions(param) {
    return this.rest.get('GET_OPENED_BY_USER', param);
  }
  getClosePositions(param) {
    return this.rest.get('GET_CLOSED_ALL', param);
  }
  getManulGateway(param) {
    return this.rest.get('GET_PAYMENT_GATEWAY_MANUAL_ALL', param);
  }
  getAutoGateway(param) {
    return this.rest.get('GET_PAYMENT_GATEWAY_AUTO_ALL', param);
  }
  makeManualDeposit(param) {
    return this.rest.post('MAKE_MANUAL_DEPOIST', param);
  }
  makeManualWithdraw(param) {
    return this.rest.post('MAKE_MANUAL_WITHDRAW', param);
  }
  makeW2WTransfer(param) {
    return this.rest.post('MAKE_WALLET_INTERNAL_TRANSFER', param);
  }
  cCRecharge(param) {
    return this.rest.get('MAKE_CASH_RECHARGE', param);
  }
  getLedger(param) {
    return this.rest.get('GET_USER_WALLET_LEDGER_v2', param);
  }
  claim(param) {
    return this.rest.post('CLAIM_PENDING_BALANCE', param);
  }
  walletTrans(param) {
    return this.rest.post('MAKE_WALLET_TRANS', param);
  }
  // getSettings(param) {
  //   return this.rest.get('GET_TRNx_SETTINGS', param);
  // }
  getSettings(param) {
    return this.rest.get('GET_TRNx_SETTINGS_v2', param);
  }
  MAKE_CASH_RECHARGE_BY_PROFILE(param) {
    return this.rest.get('MAKE_CASH_RECHARGE_BY_PROFILE', param);
  }
  
  InternalTransfer(param) {
    return this.rest.post('MAKE_INTERNAL_TRANSFER', param);
  }
  getAllTrans(param) {
    return this.rest.get('GET_TRANSACTION_ALL', param);
  }
  editUser(param) {
    return this.rest.get('UPDATE_KYC', param);
  }
  createTicket(param) {
    return this.rest.post('MAKE_SUPPORT_TICKET', param);
  }
  edit(param) {
    return this.rest.post('EDIT_PROFILE', param);
  }
  
  changePass(param) {
    return this.rest.get('PROFILE_PWD_CHANGE', param);
  }
  getTicket(param) {
    return this.rest.get('GET_CLNT_TKT', param);
  }
  getTicketMessage(param) {
    return this.rest.get('GET_CLNT_TKT_MESSAGE', param);
  }
  // getIbPartner(param) {
  //   return this.rest.get('GET_IBPartner', param);
  // }

  getIbPartner(param) {
    return this.rest.get('GET_IB_PROFILE_HIER', param);
  }
  addIbreq(param) {
    return this.rest.post('ADD_IBREQUEST', param);
  }
  editTicket(param) {
    return this.rest.get('UPDATE_SUPPORT_TICKET', param);
  }
  makeMessage(param) {
    return this.rest.post('MAKE_SUPPORT_MESSAGE', param);
  }
  getTier(param) {
    return this.rest.get('GET_IBHIERARCHY', param);
  }
  getAffl(param) {
    return this.rest.get('GET_AFFL_HIER_v2', param);
  }
  getAffl1(param) {
    return this.rest.get('GET_AFFL_HIER', param);
  }
  getProfile(param) {
    return this.rest.get('GET_IB_PROFILE_HIER', param);
  }
  getIbDaily(param) {
    return this.rest.get('GET_RPT_IB_DAILY_RANGE', param);
  }
  commissionOfUser(param) {
    return this.rest.get('GET_RPT_COMMISSION_PAY_BYIB', param);
  }
  admDepWithAmount(param) {
    return this.rest.post('MAKE_WALLET_ADM_TRANS', param);
  }
  makeDeposit(param) {
    return this.rest.get('MAKE_DEPOIST_BALANCE', param);
  }
  updateCommPay(param) {
    return this.rest.get('UPDATE_COMMISSION_PAY', param);
  }
  afterVerification(param) {
    return this.rest.get('MAKE_SIGNUP_AFTER_VERIFICATION', param);
  }
  makePassUpdate(param) {
    return this.rest.post('MAKE_SIGNUP_UPDATE_PWD', param);
  }
  // getUserSignal(param) {
  //   return this.rest.get1('GET_USER_SIGNALS', param);
  // }
  getUserSignal(param) {
    return this.rest.get1('GET_MENTOR_SIGNALS', param);
  }
  getUserSignalRT(param) {
    return this.rest.get1('GET_USER_SIGNALS_RT', param);
  }
  getMentorSignal(param) {
    return this.rest.get1('GET_MENTOR_SIGNALS', param);
  }
  getSignalHistory(param) {
    return this.rest.get1('GET_SIGNAL_HISTORY', param);
  }
  getSignalByR(param) {
    return this.rest.get1('GET_MENTOR_SIGNALS_BYRANGE', param);
  }
  getOverAll(param) {
    return this.rest.get1('GET_LEADER_OVERALL_PERFORMANCE', param);
  }
  getLeadrRet(param) {
    return this.rest.get1('GET_LEADER_RETURN_ANALYSIS', param);
  }
  getLeadrSymbol(param) {
    return this.rest.get1('GET_LEADER_SYMBOL_ANALYSIS', param);
  }
  makeAffReq(param) {
    return this.rest.post('MAKE_AFFILIATE_SIGNUP', param);
  }
  getAffStatus(param) {
    return this.rest.get('GET_AFFILIATE_GROUP', param);
  }
  getAflbanner(param) {
    return this.rest.get('GET_AFL_BANNER', param);
  }
  getBonusCardId(param) {
    return this.rest.get('GET_BONUS_CARDID', param);
  }
  addRiskEquity(param) {
    return this.rest.post('ADD_RISK_DD_EQUITY', param);
  }
  getRiskEquity(param) {
    return this.rest.get('GET_RISK_DD_EQUITY', param);
  }
  deleteRiskEquity(param) {
    return this.rest.get('DELETE_RISK_DD_EQUITY', param);
  }
  addRiskSymb(param) {
    return this.rest.post('ADD_RISK_DD_SYMBOL', param);
  }
  getRiskSymb(param) {
    return this.rest.get('GET_RISK_DD_SYMBOL', param);
  }

  deleteRiskSymb(param) {
    return this.rest.get('DELETE_RISK_DD_SYMBOL', param);
  }
  addRiskPL(param) {
    return this.rest.post('ADD_RISK_DD_PL', param);
  }
  getRiskPL(param) {
    return this.rest.get('GET_RISK_DD_PL', param);
  }
  deleteRiskPL(param) {
    return this.rest.get('DELETE_RISK_DD_PL', param);
  }
  getAffProfiles(param) {
    return this.rest.get('GET_ALL_USER_PROFILE_v3', param);
  }
  getAdmmsg(param) {
    return this.rest.get('GET_ADM_PROFILE_MESSAGES', param);
  }
  getLoginMsg(param) {
    return this.rest.get('GET_LOGIN_PROFILE_MESSAGES', param);
  }
  updateREAD(param) {
    return this.rest.get('UPDATE_USER_READ', param);
  }
  getKycset(param) {
    return this.rest.get('GET_KYC_SETTINGS', param);
  }
  changefpass(param) {
    return this.rest.get('MAKE_RESET_PASSWORD', param);
  }
  getIBnew(param) {
    return this.rest.get('GET_PARTNER_COMMISSION_DAILY', param);
  }
  getIbLVL(param) {
    return this.rest.get('GET_COMMISSION_LVL_DAILY', param);
  }
  getDateTime(d1: any) {
    var d = new Date(d1);
    var r =
      d.getUTCFullYear() +
      '-' +
      d.getUTCMonth() +
      '-' +
      d.getUTCDate() +
      ' ' +
      d.getUTCHours() +
      ':' +
      d.getUTCMinutes() +
      ':' +
      d.getUTCSeconds();
    return r;
  }
  mUpload(params: any) {
    return this.rest.post2('common/uploadFiles', params);
  }

  GenPassword(n: number = 6) {
    const key = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789~!@#$%^&*()[]{}|:;<>?';
    let pwd: string = '';
    for (let i = 0; i < n; i++) {
      const r = Math.floor(Math.random() * Math.floor(key.length - 1));
      pwd = pwd.concat(key.charAt(r));
    }
    return pwd;
  }

  toCheckAlpha(v) {
    let message = '';
    var letterNumber = /^[0-9a-zA-Z]+$/;
    if (v.match(letterNumber)) {
      return (message = '');
    } else {
      return (message = 'Please enter a alphanumaric password');
    }
  }

  validatePassword(p: string, errors: any[]) {
    // if(errors.length>5){
    //   errors=[];
    // }
    try {
      if (p.length < 8) {
        errors.push('Your password must be at least 8 characters');
      }
      if (p.search(/[a-z]/i) < 0) {
        errors.push('Your password must contain at least one small letter.');
      }
      var format = /[A-Z]/;
      if (format.test(p)) {
      } else {
        errors.push('Your password must contain at least one capital letter.');
      }

      // if (p.search(/[A-Z]/i) < 0) {
      //   errors.push('Your password must contain at least one capital letter.');
      // }
      if (p.search(/[0-9]/) < 0) {
        errors.push('Your password must contain at least one digit.');
      }

      format = /[!@#$%^&*()_+\-=\[\]{};':'\\|,.<>\/?]+/;
      if (format.test(p)) {
      } else {
        errors.push(
          'Your password must contain at least one special character.'
        );
      }
      if (errors.length > 0) {
        // alert(errors.join('\n'));
        return false;
      }
      return true;
    } catch (e) {
      return false;
    }
  }

  /* Common Method*/
  GetCountry(code: string) {
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < this.conf.countries.length; i++) {
      if (code.toLowerCase() == this.conf.countries[i].code.toLowerCase()) {
        return this.conf.countries[i].name.toUpperCase();
      }
    }
  }

  LocalTimeString(ms) {
    var d = new Date(parseFloat(ms));
    const myMoment: moment.Moment = moment(d);
    return myMoment.format('YYYY-MM-DD hh:mm A');
  }

  TimeString(ms, s = 0) {
    var d = new Date(parseFloat(ms));
    const myMoment: moment.Moment = moment(d);
    return myMoment.format('YYYY-MM-DD') + (s == 0 ? ' 00:00:00' : ' 23:59:59');
  }

  getTimeStamp() {
    var time = new Date().getTime();
    var d = new Date(time);
    const myMoment: moment.Moment = moment(d);
    const Timestamp = {
      sCreadedOn: time,
      sCreadedOn_Str: myMoment.format('YYYY-MM-DD hh:mm A'),
      sUpdatedOn: time,
      sUpdatedOn_Str: myMoment.format('YYYY-MM-DD hh:mm A')
    };
    return Timestamp;
  }

  DateString(str: string, op: number = 0) {
    if (op == 0) {
      return str.split(' ')[0];
    } else {
      return str.split(' ')[1];
    }
  }
  public setTitle(newTitle: string) {
    // this.conf.AppName.subscribe(data => {
    //   this.titleService.setTitle(
    //     (newTitle == '/' || '' ? '' : newTitle + ' - ') + data
    //   );
    // });
  }
  error(msg: any, time: any = 3000) {
    this.Notify.error('Error', msg, {
      timeOut: time,
      showProgressBar: true,
      pauseOnHover: false,
      clickToClose: true,
      maxLength: 20
    });
  }
  success(msg: any, time: any = 3000) {
    this.Notify.success('Success', msg, {
      timeOut: time,
      showProgressBar: true,
      pauseOnHover: false,
      clickToClose: true,
      maxLength: 20
    });
  }
  warning(msg: any, time: any = 3000) {
    this.Notify.warn('Warning', msg, {
      timeOut: time,
      showProgressBar: true,
      pauseOnHover: false,
      clickToClose: true,
      maxLength: 20
    });
  }
  redirect(link) {
    this.router.navigate(['/' + link]);
  }
  replareAll(text: string, search: string, replace: string) {
    return text.replace(new RegExp(search, 'g'), replace);
  }
  spin(v) {
    if (v == true) {
      this.spiner.show();
    } else {
      this.spiner.hide();
    }
  }

  validate(value, type) {
    let msg: string = '--->';
    switch (type) {
      case 'email':
        if (
          value.match(
            // tslint:disable-next-line: max-line-length
            /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/
          )
        ) {
          msg = '';
        } else if (value == '') {
          msg = '';
        } else {
          msg = 'Invalid Email';
        }
        break;
    }
    return msg;
  }

  check(val, t, newVal) {
    let msg: string = '--->';
    switch (t) {
      case 'password':
        if (val != newVal && val != '' && newVal != '') {
          msg = 'Confirm Password should match the new password';
        } else {
          msg = '';
        }
        break;
    }
    return msg;
  }
  post(obj, url, target = null) {
    var mapForm = document.createElement('form');
    mapForm.target = target != null ? target : '_self';
    mapForm.method = 'POST'; // or 'post' if appropriate
    mapForm.action = url;
    // tslint:disable-next-line: only-arrow-functions
    Object.keys(obj).forEach(function(param) {
      var mapInput = document.createElement('input');
      mapInput.type = 'hidden';
      mapInput.name = param;
      mapInput.setAttribute('value', obj[param]);
      mapForm.appendChild(mapInput);
    });
    document.body.appendChild(mapForm);
    // console.log(mapForm);
    mapForm.submit();
  }
  GET_ACCOUNT_VERIFICATION(param) {
   return this.rest.post('GET_ACCOUNT_VERIFICATION', param);
  }

  GET_MT4_MANAGERS(param) {
  return this.rest.get('GET_MT4_MANAGERS', param);
  }
  CONFIGURE_ACCOUNT(param) {
  return this.rest.post('CONFIGURE_ACCOUNT', param);
  }
  OPEN_ACCOUNT_INFO_EDIT(param) {
    return this.rest.post('OPEN_ACCOUNT_INFO_EDIT', param);
  }
  openDemoAcc(param) {
    return this.rest.post('OPEN_ACCOUNT_INFO_EDIT', param);
  }
  GET_PROFILE_ACCOUNT_SNAP(param) {
    return this.rest.get('GET_PROFILE_ACCOUNT_SNAP', param);
  }
  GET_PROFILE_ACCOUNTS(param) {
    return this.rest.get('GET_PROFILE_ACCOUNTS', param);
  }
  DELETE_AFFILIATE_PROFILE(param) {
    return this.rest.get('DELETE_AFFILIATE_PROFILE', param);
  }
  MAKE_CASH_RECHARGE(param) {
    return this.rest.get('MAKE_CASH_RECHARGE', param);
  }
  GET_CASH_CARD_TRANS(param) {
    return this.rest.get('GET_CASH_CARD_TRANS', param);
  }
  MAKE_SIGNUP_AFTER_VERIFICATION(param) {
    return this.rest.get('MAKE_SIGNUP_AFTER_VERIFICATION', param);
  }
  MAKE_SIGNUP_UPDATE_PWD(param) {
    return this.rest.post('MAKE_SIGNUP_UPDATE_PWD', param);
  }
}
